import type { IBaseTrackData, IDataStore, IExtraTrackData, IGetFullTrackData, IParamData } from '@/types/DataStore';
import _ from 'lodash';
import PlatformProxy from './PlatformProxy.ts';

export class DataStore implements IDataStore {
  private baseData: IBaseTrackData;
  private extraData: IExtraTrackData = {};
  private isDebug = false;
  private pageDataSnap: (IBaseTrackData & IExtraTrackData) | any = {};
  private platform: PlatformProxy = PlatformProxy.getInstance();
  public constructor(initData: IBaseTrackData, isDebug = false) {
    this.baseData = initData;
    this.isDebug = isDebug;
    const { traceSessionId, sessionId } = this.platform.getSessions();
    this.baseData.sessionId = sessionId;
    this.baseData.traceSessionId = traceSessionId;
  }
  public setPageDataSnap(snapData?: IExtraTrackData) {
    console.log('snapData: ', snapData);
    this.pageDataSnap = snapData || {};
  }
  public setBaseDataObj(obj: IBaseTrackData) {
    _.merge(this.baseData, obj);
    if (this.isDebug) {
      console.group('setBaseObj');
      console.table(obj);
      console.groupEnd();
      console.log('dataStore base: ', this.baseData);
    }
  }
  public setBaseData(key: keyof IBaseTrackData, value?: string) {
    this.baseData[key] = value || '';
    if (this.isDebug) {
      console.group('setBase');
      console.table({ [key]: value });
      console.groupEnd();
    }
  }
  public setExtraDataObj(obj: IExtraTrackData) {
    _.merge(this.extraData, obj);
    if (this.isDebug) {
      console.group('setExtraObj');
      console.table(obj);
      console.groupEnd();
    }
  }
  public setExtraData(key: keyof IExtraTrackData, value?: IParamData | string): void {
    this.extraData[key] = value || null;
    if (this.isDebug) {
      console.group('setExtra');
      console.table({ [key]: value });
      console.groupEnd();
    }
  }
  public getFullData() {
    this.setCommonData();
    console.log('dataStore base: ', this.baseData);
    console.log('dataStore extra: ', this.extraData);
    console.log('dataStore pageSnap: ', this.pageDataSnap);
    return {
      ...this.baseData,
      ...this.extraData,
      param: JSON.stringify(_.merge({}, this.pageDataSnap?.param || {}, this.extraData?.param || {})),
    };
  }

  public getData(key?: keyof IGetFullTrackData) {
    if (key) {
      return this.baseData[key] || this.extraData[key] || null;
    } else {
      return {
        ...this.baseData,
        ...this.extraData,
      };
    }
  }
  private setCommonData() {
    this.baseData.time = String(new Date().getTime());
    this.platform.setStoreBaseData(this.baseData);
  }
}
